module.exports = __webpack_public_path__ + "img/bannerajuda.939d07bd.jpg";